// Focus on mobile search field after clicking search in footer
function focusMethod() {
    document.getElementById("search_mobile_query").focus();
}